<template>
  <div class="bs-dialog">
    <div class="bs-dialog__box">
      <div class="bs-dialog__header">
        {{ title }}
        <div class="bs-dialog__close" @click="close"></div>
      </div>
      <div class="bs-dialog__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "我是标题",
    },
    close: {
      type: Function,
    },
  },
};
</script>

<style lang="scss">
.bs-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0,0,0,.5);
  // display: none;
}
.bs-dialog__box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 54vw;
  height: 80vh;
  border: 1px solid #0299C9;
  // box-shadow: 0 0 30px #053576 inset;
  background: rgb(5,39,162);
  background: linear-gradient(145deg, rgba(5,39,162, 0.9) 0%, rgba(26,44,119, 0.9) 100%);
  box-sizing: border-box;
}
.bs-dialog__header {
  height: 70px;
  line-height: 70px;
  position: relative;
  color: var(--main-color);
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  user-select: none;

  &::after {
    content: "";
    display: block;
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(145deg, rgba(2, 158, 204, 0) 0%, rgba(2, 158, 204, 1) 50%, rgba(2, 158, 204, 0) 100%);
  }
}
.bs-dialog__close {
  position: absolute;
  width: 60px;
  height: 60px;
  color: rgba(2, 158, 204, 1);
  right: 0;
  top: 0;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.bs-dialog__close:before {
  position: absolute;
  content: "";
  width: 20px;
  height: 3px;
  background: rgba(2, 158, 204, 1);
  transform: rotate(45deg);
  top: 50%;
  right: 20px;
}

.bs-dialog__close:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 3px;
  top: 50%;
  background: rgba(2, 158, 204, 1);
  transform: rotate(-45deg);
  right: 20px;
}
.bs-dialog__content {
  height: calc(100% - 70px);
  overflow: auto;
}
</style>
